(function ($) {
  'use strict';

  $(document).ready(function () {
    $('body').on('click', '.new-window', function (ev) {
      window.open($(this).attr('href'), 'Share', 'chrome=yes,centerscreen=yes,outerWidth=600,outerHeight=300,menubar=no,toolbar=no,location=no,personalbar=no');
      ev.preventDefault();
    });
  });
})(jQuery);
